import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_302: DocMigration = {
  maxSchemaVersion: "0.0.302",
  description: "Foundation assembly overrides from static room layout to room.",
  apply(json: any): any {
    const roomEdgeBehaviors: { [id: string]: any } = {};
    let count = Object.keys(json.roomEdgeBehaviors).length;
    for (const roomId in json.staticRoomLayouts) {
      const staticRoomLayout = json.staticRoomLayouts[roomId];
      if (!staticRoomLayout) {
        continue;
      }

      const foundationAssemblies = staticRoomLayout?.foundationAssemblies;
      if (!foundationAssemblies?.length) {
        // I realize this can orphan empty arrays, but staticRoomLayout will get removed in 8th and final migration of this set.
        continue;
      }

      for (const foundationAssembly of foundationAssemblies) {
        const id = uid();
        roomEdgeBehaviors[id] = {
          ...foundationAssembly,
          entityType: "EDGE_BEHAVIOR",
          edgeBehaviorType: "FOUNDATION_ASSEMBLY",
          sortIndex: count++,
          parentId: roomId,
          id,
        };
      }

      delete staticRoomLayout.foundationAssemblies;
    }

    json.roomEdgeBehaviors = { ...json.roomEdgeBehaviors, ...roomEdgeBehaviors };
    return json;
  },
};

export default migration_0_0_302;
